// extracted by mini-css-extract-plugin
module.exports = {"loadWrapper":"PromiseSpinner_loadWrapper__j-I2I","loaderLabel":"PromiseSpinner_loaderLabel__2vt72","loader":"PromiseSpinner_loader__1Uqhf","load1":"PromiseSpinner_load1__25ino"};